module.exports = __webpack_public_path__ + "static/media/ville_de_creteil.ba9d663a.png";